export default __webpack_public_path__ + "static/media/domJan2026-Th.65b4288a.jpg";